﻿export default class News {
  constructor(obj) {
    if (obj) {
      obj && Object.assign(this, obj)
      return
    }

    this.ID = 0
    this.Title = ''
    this.Contents = ''
    this.Created = ''
    this.Updated = ''
    this.Unpublish = ''
    this.Author = ''
    this.CanInteract = 'true'
    this.MustSign = 'false'
    this.Likes = 0
    this.Comments = 0
    this.IsPush = 'true'
    this.IsEmail = 'false'
    this.Images = []
    this.Videos = []
    this.Links = []
    this.Poll = {}
    this.Groups = []
    this.Users = []
    this.UserHasSeen = false
    this.ReadCount = 0
    this.UnreadCount = 0
    this.UserIDRef = 0
    this.HasPoll = false
    this.PollAnswerCount = 0
    this.IsSocialWall = false
    this.Pinned = false
  }
}
